import React from 'react';
import { Typography, Link, CardTitle } from '@one-thd/sui-atomic-components';
import { listHeaderPropTypes } from '../utils/propTypes';

const ListHeader = ({ name, url, itemCount }) => (
  <CardTitle
    header={(
      <Typography lineClamp="2" decoration="underline" component="h3" height="normal">
        <Link
          href={url}
          color="primary"
          className="sui-text-base @2xl:sui-text-lg sui-text-primary !sui-font-bold !sui-capitalize sui-break-all"
        >
          {name}
        </Link>
      </Typography>
    )}
    subheader={(
      <span className="sui-hidden @sm:sui-flex">
        {`Total Items: ${itemCount}`}
      </span>
    )}
  />
);

// Use the prop types defined in the utils/propTypes.js file
ListHeader.propTypes = listHeaderPropTypes;

export default ListHeader;
